var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group"},[_vm._v(" Content below this sentence will be visible only for Premium Users. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }